import init from './init.js';
import SwapContainer from './SwapContainer.js';
import { autoplay, syncplay, duplicate, getTimeOfTheDay } from './helpers.js';

const width = 1080;
const height = 1920;
PIXI.settings.TARGET_FPMS = 0.009;

const [timeOfTheDay, restTimesOfTheDay] = getTimeOfTheDay();

const manifest = {
  width,
  height,
  bundles: [
    {
      name: 'preload',
      root: 'assets/1/',
      assets: [
        {
          name: `background-${timeOfTheDay}`,
          srcs: `background/background-${timeOfTheDay}.png`,
        },
        {
          name: `sky-${timeOfTheDay}`,
          srcs: `sky/sky-${timeOfTheDay}.png`,
        },
        { name: 'mountain', srcs: 'mountain/mountain-1.png' },
        { name: 'tv', srcs: 'tv/tv-1.png' },
        { name: 'gesha-1', srcs: 'gesha/gesha-1.png' },
        { name: 'face-1', srcs: 'face/face-1.json' },
        { name: 'cloud-spritesheet', srcs: 'cloud/cloud.json' },
        { name: 'rain-spritesheet', srcs: 'rain/rain.json' },
        { name: 'pocky-spritesheet', srcs: 'pocky/pocky.json' },
      ],
    },
    {
      name: 'background',
      root: 'assets/1/',
      assets: [
        {
          name: 'fire',
          srcs: 'fire/fire.json',
        },
        { name: 'empty', srcs: 'empty.png' },
        { name: 'gesha-2', srcs: 'gesha/gesha-2.png' },
        { name: 'face-2', srcs: 'face/face-2.json' },
      ],
    },
    {
      name: 'final',
      root: 'assets/1/',
      assets: [
        { name: 'finger-spritesheet', srcs: 'finger/finger.json' },
        ...restTimesOfTheDay.map((str) => ({
          name: `background-${str}`,
          srcs: `background/background-${str}.png`,
        })),
        ...restTimesOfTheDay.map((str) => ({
          name: `sky-${str}`,
          srcs: `sky/sky-${str}.png`,
        })),
      ],
    },
  ],
};

async function main() {
  const { app, getAssetOfBundle, Sprite, AnimatedSprite } = await init(
    manifest
  );

  const preloadAssets = await PIXI.Assets.loadBundle('preload');
  PIXI.Assets.backgroundLoadBundle('background');

  const getPreloadAsset = getAssetOfBundle('preload', preloadAssets);

  const background1 = new Sprite(getPreloadAsset(`background-${timeOfTheDay}`));
  background1.name = `background-${timeOfTheDay}`;

  const backgroundSwapContainer = new SwapContainer(background1);
  backgroundSwapContainer.showOne(`background-${timeOfTheDay}`);

  const sky1 = new Sprite(getPreloadAsset(`sky-${timeOfTheDay}`));
  sky1.name = `sky-${timeOfTheDay}`;

  const skySwapContainer = new SwapContainer(sky1);
  skySwapContainer.showOne(`sky-${timeOfTheDay}`);

  const mountain = new Sprite(getPreloadAsset('mountain'));
  const tv = new Sprite(getPreloadAsset('tv'));

  const body1 = new Sprite(getPreloadAsset('gesha-1'));

  const face1 = new AnimatedSprite(
    getPreloadAsset('face-1').animations['005-gesha']
  );
  face1.animationSpeed = 0.666;
  face1.play();

  const gesha1 = new PIXI.Container();
  gesha1.name = 'gesha-1';
  gesha1.addChild(body1, face1);

  const geshaSwapContainer = new SwapContainer(gesha1);
  geshaSwapContainer.showOne('gesha-1');
  geshaSwapContainer.interactive = true;
  geshaSwapContainer.hitArea = new PIXI.Polygon(
    545,
    28,
    276,
    183,
    441,
    334,
    322,
    419,
    60,
    1152,
    711,
    1301,
    1033,
    1227,
    957,
    634,
    696,
    324,
    695,
    153
  );
  geshaSwapContainer.on('pointerdown', () => {
    console.log('hi');
    if (geshaSwapContainer.activeName === 'gesha-1') {
      geshaSwapContainer.showOne('gesha-2');
    } else {
      geshaSwapContainer.showOne('gesha-1');
    }
  });

  console.log(geshaSwapContainer);

  const rain = new AnimatedSprite(
    getPreloadAsset('rain-spritesheet').animations['004-rain']
  );
  const cloud = new AnimatedSprite(
    getPreloadAsset('cloud-spritesheet').animations['001-cloud']
  );
  const pocky = new AnimatedSprite(
    getPreloadAsset('pocky-spritesheet').animations['008-pocky']
  );

  rain.play();

  pocky.hitArea = new PIXI.Rectangle(525, 368, 90, 83);
  pocky.interactive = true;
  pocky.loop = false;
  pocky.animationSpeed = 0.666;

  pocky.on('pointerdown', () => {
    pocky.gotoAndPlay(0);
  });
  pocky.onComplete = () => {
    pocky.gotoAndStop(0);
  };

  cloud.animationSpeed = 0.333;

  syncplay(() => {
    cloud.play();
  }, 3);

  const fingerContainer = new PIXI.Container();

  app.stage.addChild(
    backgroundSwapContainer,
    cloud,
    skySwapContainer,
    mountain,
    rain,
    geshaSwapContainer,
    fingerContainer,
    tv,
    pocky
  );

  const backgroundAssets = await PIXI.Assets.loadBundle('background');
  const getBackgroundAssets = getAssetOfBundle('background', backgroundAssets);

  const body2 = new Sprite(getBackgroundAssets('gesha-2'));
  const face2 = new AnimatedSprite(
    getBackgroundAssets('face-2').animations['005-gesha02']
  );
  face2.animationSpeed = 0.666;
  face2.play();

  const gesha2 = new PIXI.Container();
  gesha2.name = 'gesha-2';
  gesha2.addChild(body2, face2);

  geshaSwapContainer.addChild(gesha2);
  geshaSwapContainer.showOne('gesha-1');

  const fire = new AnimatedSprite([
    ...duplicate(getBackgroundAssets('empty'), 15),
    ...getBackgroundAssets('fire').animations['009-on_fire'],
    getBackgroundAssets('empty'),
  ]);

  fire.loop = false;

  autoplay(() => {
    fire.gotoAndPlay(0);
  }, 0);

  app.stage.addChild(fire);

  const finalAssets = await PIXI.Assets.loadBundle('final');
  const getFinalAssets = getAssetOfBundle('final', finalAssets);

  const finger = new AnimatedSprite(
    getFinalAssets('finger-spritesheet').animations['finger']
  );
  finger.hitArea = new PIXI.Rectangle(451, 470, 217, 97);
  finger.interactive = true;
  finger.loop = false;
  finger.animationSpeed = 0.666;
  finger.on('pointerdown', () => {
    finger.gotoAndPlay(0);
  });
  finger.onComplete = () => {
    finger.gotoAndStop(0);
  };

  fingerContainer.addChild(finger);

  const background2 = new Sprite(
    getFinalAssets(`background-${restTimesOfTheDay[0]}`)
  );
  background2.name = `background-${restTimesOfTheDay[0]}`;
  background2.visible = false;

  const background3 = new Sprite(
    getFinalAssets(`background-${restTimesOfTheDay[1]}`)
  );
  background3.name = `background-${restTimesOfTheDay[1]}`;
  background3.visible = false;

  backgroundSwapContainer.addChild(background2, background3);

  const sky2 = new Sprite(getFinalAssets(`sky-${restTimesOfTheDay[0]}`));
  sky2.name = `sky-${restTimesOfTheDay[0]}`;
  sky2.visible = false;

  const sky3 = new Sprite(getFinalAssets(`sky-${restTimesOfTheDay[1]}`));
  sky3.name = `sky-${restTimesOfTheDay[1]}`;
  sky3.visible = false;

  skySwapContainer.addChild(sky2, sky3);

  setInterval(() => {
    const [timeOfTheDayStr] = getTimeOfTheDay();
    skySwapContainer.showOne(`sky-${timeOfTheDayStr}`);
    backgroundSwapContainer.showOne(`background-${timeOfTheDayStr}`);
  }, 60 * 1000);
}

main();
